import { useState } from 'react'
import toast from 'react-hot-toast'
import { StepProps } from '../TimsurveyWizard'
import { timsurveyApi } from '../../../services/api'
import SignatureCanvasPad from '../../../components/timsurvey/SignatureCanvasPad'
import { RuoloFirmaTimsurvey } from '../../../types/timsurvey'

const RUOLI_LABEL: Record<RuoloFirmaTimsurvey, string> = {
  CLIENTE: 'Cliente',
  IMPRESA: 'Impresa',
  VENDITA: 'Vendita',
}

const RUOLI_RICHIESTI: RuoloFirmaTimsurvey[] = ['CLIENTE', 'IMPRESA', 'VENDITA']

async function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const result = reader.result as string
      resolve(result.split(',')[1] ?? '')
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

export default function StepFirme({ pratica, form, setForm, onNext, onBack, salvaBozza }: StepProps) {
  const [ruoloIndex, setRuoloIndex] = useState(0)
  const [nomeFirmatario, setNomeFirmatario] = useState('')
  const [inviando, setInviando] = useState(false)

  const scegliScenario = async (scenario: 'A' | 'B') => {
    setForm(f => ({ ...f, scenario_firma: scenario }))
    await salvaBozza()
  }

  if (!form.scenario_firma) {
    return (
      <div className="card p-4 space-y-3">
        <p className="text-sm text-slate-600">
          Scenario A: sopralluogo standard o fuori standard con ore condivise sul posto.<br />
          Scenario B: fuori standard con ore da inserire a valle.
        </p>
        <div className="grid grid-cols-2 gap-3">
          <button className="btn-secondary" onClick={() => scegliScenario('A')}>Scenario A</button>
          <button className="btn-secondary" onClick={() => scegliScenario('B')}>Scenario B</button>
        </div>
        <button className="btn-secondary w-full" onClick={onBack}>Indietro</button>
      </div>
    )
  }

  const ruoli = RUOLI_RICHIESTI
  const ruolo = ruoli[ruoloIndex]

  if (!ruolo) {
    return (
      <div className="card p-4 text-center space-y-3">
        <p className="text-sm text-slate-600">Tutte le firme richieste sono state acquisite.</p>
        <button className="btn-primary w-full" onClick={onNext}>Avanti</button>
      </div>
    )
  }

  const handleFirma = async (blob: Blob) => {
    if (!nomeFirmatario.trim()) {
      toast.error('Inserisci il nome del firmatario')
      return
    }
    setInviando(true)
    try {
      const base64 = await blobToBase64(blob)
      await timsurveyApi.firme.add(pratica.id, ruolo, nomeFirmatario, base64)
      toast.success(`Firma ${RUOLI_LABEL[ruolo]} acquisita`)
      setNomeFirmatario('')
      setRuoloIndex(i => i + 1)
    } catch (err: any) {
      toast.error(err.response?.data?.detail ?? 'Errore salvataggio firma')
    } finally {
      setInviando(false)
    }
  }

  return (
    <div className="card p-4 space-y-3" style={{ minHeight: '60vh' }}>
      <div className="text-sm text-slate-500">Firma richiesta: <strong>{RUOLI_LABEL[ruolo]}</strong> ({ruoloIndex + 1}/{ruoli.length})</div>
      <div>
        <label className="label">Nome e cognome firmatario</label>
        <input
          type="text"
          className="input w-full"
          value={nomeFirmatario}
          onChange={e => setNomeFirmatario(e.target.value)}
          disabled={inviando}
        />
      </div>
      <SignatureCanvasPad confirmLabel={`Conferma Firma ${RUOLI_LABEL[ruolo]}`} onConfirm={handleFirma} />
    </div>
  )
}
